import * as React from "react";
import {Card} from "reactstrap";

export default class LimitIncreaseCardView extends React.Component {

    render() {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "65%",
            margin: "auto",
            paddingTop: "15px",
            maxHeight: "75%"
        }}>
            <div style={{
                overflowY: "scroll",
                overflowX: "hidden"
            }}
                 className={"browser-card"}
            >
                {this.props.component}
            </div>
        </Card>
    }
}